<template>
	<div>
		<h2>Devices</h2>
		<spinner v-if="devices.loading"/>
		<div v-if="!devices.loading && devices.data.length" class="idi-table devices">
			<div class="idi-header">
				<div class="idi-cell">Name</div>
			</div>
			<div class="idi-row" v-for="device in devices.data" :key="device.id">
				<div class="idi-cell">{{ device.name }}</div>
			</div>
		</div>
		<p v-if="!devices.loading && !devices.data.length" class="no-results">No results found.</p>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			devices: {
				loading: false,
				error: null,
				data: []
			}
		}
	},
	methods: {
		getDevices () {
			this.devices.loading = true
			this.devices.data = []
			this.$api.users.notifications.getDevices(this, this.user_uid).then(response => {
				this.$log.info('user profile', 'users.notifications.getDevices OK', response)()
				this.devices.data = response.body
			}).catch(error => {
				this.$log.error('user profile', 'users.notifications.getDevices ERROR', error)()
				this.devices.error = error
			}).finally(() => {
				this.devices.loading = false
			})
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title('Notifications')
			vm.getDevices()
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/Notifications.vue